import React from 'react'
import styled from 'styled-components/macro'

const Wrapper = styled.div`
  padding: 25px 40px 0 40px;
`

export const StepWrapper = ({ children }) => <Wrapper>{children}</Wrapper>
